import './styles/ocr.css';
import { initOcrFeature } from './features/ocr/ocr-controller.js';

async function boot() {
  // Mount OCR first so a failure in the historical translator cannot hide it.
  initOcrFeature();
  try {
    await import('../app.js');
  } catch (error) {
    console.error('TransLucide legacy translator failed to initialize.', error);
    document.documentElement.dataset.legacyInitError = 'true';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
